import { render, staticRenderFns } from "./ClientAlertsReportTemplate.vue?vue&type=template&id=4f1bafc0"
import script from "./ClientAlertsReportTemplate.vue?vue&type=script&lang=js"
export * from "./ClientAlertsReportTemplate.vue?vue&type=script&lang=js"
import style0 from "./ClientAlertsReportTemplate.vue?vue&type=style&index=0&id=4f1bafc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports